import { render, staticRenderFns } from "./CashFlowStatement-demowithdummydata.vue?vue&type=template&id=b4050468&scoped=true"
import script from "./CashFlowStatement-demowithdummydata.vue?vue&type=script&lang=js"
export * from "./CashFlowStatement-demowithdummydata.vue?vue&type=script&lang=js"
import style0 from "./CashFlowStatement-demowithdummydata.vue?vue&type=style&index=0&id=b4050468&prod&scoped=true&lang=css"
import style1 from "./CashFlowStatement-demowithdummydata.vue?vue&type=style&index=1&id=b4050468&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4050468",
  null
  
)

export default component.exports